module.exports = __webpack_public_path__ + "img/lincoln-okc.d1be1487.jpeg";